
let formatBillTypeClass = value => {    //名单类型class

};


export {
  formatBillTypeClass
}



// WEBPACK FOOTER //
// ./src/filter/commonFilter.js